module.exports = __webpack_public_path__ + "static/img/4.9a896a1d.jpg";